module.exports = __webpack_public_path__ + "static/media/five.03d1a238.svg";